export enum EngineerType {
  Heart = "heart",
  Kidneys = "kidneys",
  Pancreas = "pancreas",
  HeartPancreas = "heart_pancreas",
  PancreasKidneys = "pancreas_kidneys",
  KidneysHeart = "kidneys_heart"
}